import React from 'react';

const SvgWrapper = ({ children }) => {
  return <>{children}</>;
};

export default SvgWrapper;
